import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { PetDetailsRadios } from '../../../petDetailRadios/petDetailsRadios';
import { GetPetDetailsFromPolicyNumber } from '../../../../helpers/petHelpers';
import { FullPetDetailsPropTypes } from '../../../../propTypes/petDetails';
import ErrorText from '../../../shared/ErrorText/ErrorText';
import { FORM_KEYS } from '../../../../constants/formKeys';

export const PetSelection = ({ isReadOnly, petDetails, onPetSelection, activePolicyNumber }) => {
  const formContext = useFormContext();
  const fieldState = formContext.getFieldState(FORM_KEYS.PET_DETAILS_RADIOS);

  const handlePetSelection = (policyNumber) => {
    onPetSelection({
      policyNumber,
      petDetail: GetPetDetailsFromPolicyNumber({ petDetails, policyNumber })
    });
  };

  return (
    <section>
      <ErrorText
        cssClass="custom_validation"
        message={[{ value: 'Please select a pet', isDisplayed: fieldState.invalid }]}
      />
      <PetDetailsRadios
        value={activePolicyNumber}
        petDetails={petDetails}
        isIconOnly
        isReadOnly={isReadOnly}
        onChange={handlePetSelection}
      />
    </section>
  );
};

PetSelection.propTypes = {
  isReadOnly: PropTypes.bool,
  petDetails: PropTypes.arrayOf(FullPetDetailsPropTypes),
  onPetSelection: PropTypes.func,
  activePolicyNumber: PropTypes.string
};
